// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5p-1";
export var standaloneTable = "_5p-0";